import { TicketType, TipTicket } from '../../../api/tips';
import { Tipster } from '../../Shops/Tip/interfaces/TipProduct';
import { Price } from './Price';
import { CurrencyCode } from './currencies';

interface IPrice {
  id: string;
  name: string;
  price: {
    amount: number;
    currency: CurrencyCode;
    decimals: number;
  };
  discount?: {
    amount: number;
    currency: CurrencyCode;
    decimals: number;
  };
  discount_percentage?: number;
}

export class Product {
  readonly ID: string;
  readonly name: string;
  public price: Price;
  public unlockable: boolean = false;
  public unlockedFrom: string = '';
  public unlockableID: string = '';
  public unlockableType?: TicketType;
  public discount?: { previous: Price; discounted: Price };
  public discountPercentage?: number;

  constructor({ id, name, price, discount, discount_percentage }: IPrice) {
    this.ID = id;
    this.name = name;
    this.price = new Price(price.amount, price.currency, price.decimals);

    if (discount) {
      this.discount = {
        previous: new Price(price.amount, price.currency, price.decimals),
        discounted: new Price(
          discount.amount,
          discount.currency,
          discount.decimals,
        ),
      };
      this.price = new Price(
        discount.amount,
        discount.currency,
        discount.decimals,
      );
    }

    if (discount_percentage) {
      this.discountPercentage = discount_percentage;
    }

    this.unlockable = false;
  }

  public withUnlockable(
    tipster: Tipster,
    pricingTierCode: string,
    tickets: TipTicket[],
  ): Product {
    const unlockable = tickets.find((ticket: TipTicket) => {
      /* Case for new tickets after 7.0.0 release */
      if (ticket.tipster_id || ticket.type) {
        return (
          (ticket.type === 'TIPSTER' && ticket.tipster_id === tipster.ID) ||
          ticket.type === 'UNIVERSAL'
        );
      } else {
        /* Case for old tickets with pricing tier code */
        return (
          ticket.pricing_tier_code === pricingTierCode &&
          ticket.state === 'AVAILABLE'
        );
      }
    });

    if (unlockable) {
      this.unlockable = true;
      this.unlockableID = unlockable.id;
      this.unlockableType = unlockable.type;
      this.unlockedFrom = tipster.name;
      this.price = new Price(0, this.price.currency, 2);
    }

    return this;
  }
}
